import { useMemo } from 'react';
let idCount = 0;
export const smoresIdPrefix = 'MM_SMORES';
const createId = () => {
    const id = `${smoresIdPrefix}_${idCount}`;
    idCount += 1;
    return id;
};
export const useUniqueId = (id) => {
    const returnedId = useMemo(() => id || createId(), [id]);
    return returnedId;
};
//# sourceMappingURL=id.js.map